import { Injectable } from '@angular/core';
import { MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition, MatSnackBar } from '@angular/material/snack-bar';
import { CustomSnackbarData } from '../models/custom-snackbar-data';
import { CustomSnackbarComponent } from '../../custom-snackbar/custom-snackbar.component';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

    horizontalPosition: MatSnackBarHorizontalPosition = 'right';
    verticalPosition: MatSnackBarVerticalPosition = 'top';

    constructor(private snackBar: MatSnackBar) {
    }

    successSnackBar(message: string) {
        this.snackBar.open(message, 'X', {
            duration: 3000,
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
            panelClass: ['success-snackbar'],
        });
    }

    errorSnackBar(message: string, duration: number = 4000) {
        this.snackBar.open(message, 'X', {
            duration: duration,
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
            panelClass: ['error-snackbar'],
        });
    }

    errorSnackBarDOB(message: string) {
        this.snackBar.open(message, 'X', {
            duration: 10000,
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
            panelClass: ['error-snackbar'],
        });
    }
    warningSnackBar(message: string, duration: number = 8000) {
        this.snackBar.open(message, 'X', {
            horizontalPosition: 'right',
            verticalPosition: 'top',
            duration: duration,
            panelClass: ['warning-snackbar']
        });
    }

    customSnackBar(data: CustomSnackbarData) {
        this.snackBar.openFromComponent(CustomSnackbarComponent, {
            data,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            duration: 4000,
            panelClass: ['success-snackbar']
        });
    }




}
